<template>
  <vx-card>
    <div class="flex justify-end">
      <vs-button @click="$router.push({name:'org_management_users'})" color="danger" type="filled" icon-pack="feather" icon="icon-x" class="mr-4">Cancel</vs-button>
      <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="submitForm">Save</vs-button>
    </div>

    <div v-if="dataLoaded" class="pt-8">
    <div class="vx-row mb-6">
      <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
        <span>Username</span>
      </div>
      <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="username" disabled />
      </div>
      <div class="vx-col mt-6 md:mt-0 sm:w-1/4 md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
        <span>Company</span>
      </div>
      <div class="vx-col sm:mt-6 md:mt-0 sm:w-3/4 md:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="company.name" disabled />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
        <span>URL Register</span>
      </div>
      <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="urlRegister" />
        <span class="text-danger text-sm" v-show="error.urlRegister != ''">{{error.urlRegister}}</span>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
        <span>Embed Link</span>
      </div>
      <div class="vx-col sm:w-3/4 md:w-3/4 w-full">
        <div class="flex items-start">
          <vs-textarea class="grow mr-2" v-model="embedLink" :disabled="urlRegister == ''" />
          <vs-button color="success" type="filled" icon-pack="feather" icon="icon-copy" @click.prevent="copyEmbedCode(embedLink)">Copy</vs-button>
        </div>
      </div>
    </div>
    
    <div class="font-bold">
        Embed Access
    </div>
    <span class="text-danger text-sm" v-show="error.site_access != ''">{{error.site_access}}</span>
    <div class="vx-row">
        <div class="vx-col md:w-3/4">
            <table class="table-site-access w-full">
                <tr class="bg-grey">
                    <td class="text-center w-2"><vs-checkbox v-model="accessAll"></vs-checkbox></td>
                    <th>Site Name</th>
                    <th colspan="2">Area Name</th>
                </tr>
                <tr :key="idx" v-for="(acc,idx) in tableRow">
                    <td v-if="acc.siteAccess != null" class="text-center w-2" :rowspan="acc.rowspan"><vs-checkbox v-model="siteChecked" :vs-value="acc.siteId"></vs-checkbox></td>
                    <td v-if="acc.siteAccess != null" :rowspan="acc.rowspan">{{acc.siteName}}</td>
                    <td class="text-center w-2"><vs-checkbox v-model="areaChecked" :vs-value="acc.areaId"></vs-checkbox></td>
                    <td>{{acc.areaName}}</td>
                </tr>
            </table>
        </div>
    </div>
    </div>
  </vx-card>
</template>

<script>
    import api from "@/api";
  export default {
    data() {
      return {
        dataLoaded: false,
        id: '',
        username: '',
        company: null,
        urlRegister: '',
        siteAccess: [],
        tableRow: [],
        accessAll: false,
        siteChecked: [],
        areaChecked: [],
        error: {
          urlRegister: '',
          access: ''
        }
      }
    },
    watch: {
      accessAll: function(newVal,oldVal) {
        if(oldVal != newVal) {
          if(newVal) {
            this.tableRow.forEach(val => {
              if(val.siteId != null) {
                this.siteChecked.push(val.siteId)
              }
              if(val.areaId != null) {
                this.areaChecked.push(val.areaId)
              }
            })
          } else {
            this.siteChecked = []
            this.areaChecked = []
          }
        }
      },
      siteChecked: function(newVal,oldVal) {
        if(oldVal != newVal) {
          let unchecked = ''

          oldVal.forEach(val => {
            if(newVal.indexOf(val) == -1) {
              console.log('val => ' + val)
              unchecked = val
            }
          })

          newVal.forEach(checkedSite => {
            if(checkedSite) {
              this.tableRow.forEach(val => {
                if(val.siteId === checkedSite) {
                  this.areaChecked.push(val.areaId)
                }
              })
            }
          })

          let uncheckedLists = []
          if(unchecked != '') {
            this.tableRow.forEach(val => {
                if(val.siteId === unchecked) {
                  uncheckedLists.push(val.areaId)
                }
            })
          }

          this.areaChecked = this.areaChecked.filter(val => uncheckedLists.indexOf(val) == -1)
        }
      },
    },
    computed: {
      embedLink() {
        return `<embed src="https://i-see.iconpln.co.id/embedisee?url=${this.urlRegister}" style="width:100%" height="800px">`
      }
    },
    mounted() {
      const storeData = this.$store.state.currentUser
      if(storeData != null) {
        this.company = storeData.user.company
        this.username = storeData.user.username
      }

      this.getEmbedData()
    },
    methods: {
      addOrRemove(array, value) {
          var index = array.indexOf(value);
          if (index === -1) {
              array.push(value);
          } else {
              array.splice(index, 1);
          }
      },
      getEmbedData() {
        this.$vs.loading()
        api.getEmbedSiteAccess({userId: this.$route.params.id})
        .then(result => result.data)
        .then(data => {
            if(data.status) {
              if(data.data.length > 0) {
                this.urlRegister = data.data[0].urlRegister
                this.siteAccess = data.data[0].siteEmbedAccess	

                let results = []
                if(this.siteAccess.length > 0) {
                  this.siteAccess.forEach(site => {
                    if(site.areaEmbedAccess.length > 0) {
                      site.areaEmbedAccess.forEach((area,k) => {
                        results.push({
                          siteId: site.siteId,
                          siteName: site.siteName,
                          siteAccess: k == 0 ? false : null,
                          rowspan: k == 0 ? site.areaEmbedAccess.length : null,
                          areaId: area.areaId,
                          areaName: area.areaName,
                          areaAccess: area.isAccess === 1
                        })

                        if(area.isAccess === 1) {
                          this.areaChecked.push(area.areaId)
                        }
                      })
                    }
                  })
                }

                this.tableRow = results

                this.dataLoaded = true
              }
            }
            this.$vs.loading.close()
        })
        .catch((e) => {
            console.log(e)
            this.$vs.loading.close()
        });
    },
    submitForm() {
      // reset error message
      this.error =  {
          urlRegister: '',
          access: '',
      }

      if(!this.formValidated()) {
        return;
      }

      // reset checked
      this.siteAccess.map(site => {
        site.areaEmbedAccess.map(area => {
            area.isAccess = 0
        })
      })

      // update checked
      this.siteAccess.map(site => {
        site.areaEmbedAccess.map(area => {
          if(this.areaChecked.indexOf(area.areaId) != -1) {
            area.isAccess = 1
          }
        })
      })

      console.log(this.areaChecked)
      console.log(this.siteAccess)

      this.$vs.loading()
      const postParams = {
        "userId": this.$route.params.id,
        "urlRegister": this.urlRegister,
        "siteEmbedAccess": this.siteAccess
      }
      api.saveEmbedAccess(postParams)
      .then((result) => result.data)
      .then((data) => {
          this.$vs.loading.close()
          if(!data.status) {
              this.$vs.notify({
                    title:'Error',
                    text: data.message,
                    color:'danger',
                    position:'bottom-center'
              })
          } else {
              this.$vs.notify({
                  title:'Success',
                  text:'Success update site access',
                  color:'success',
                  position:'bottom-center'
              })
              setTimeout(() => {
                this.$router.push({name:'org_management_users'})
              },500)
          }
      })
      .catch((e) => {
          console.log(e)

          this.$vs.notify({
              title:'Failed',
              text:'Update data failed',
              color:'danger',
              position:'bottom-center'
          })
          
          this.$vs.loading.close()
      });
    },
    formValidated() {
      let error = 0
      if(this.urlRegister == '' || this.urlRegister == null) {
        this.error.urlRegister = 'URL Register is required'
        error++
        this.$vs.notify({
          title:'Error',
          text: this.error.urlRegister,
          color:'danger',
          position:'bottom-center'
        })
      }
      if(this.areaChecked.length == 0) {
        this.error.access = 'Please select at least one area access'
        error++
        this.$vs.notify({
          title:'Error',
          text: this.error.access,
          color:'danger',
          position:'bottom-center'
        })
      }
      return error === 0
    },
    copyEmbedCode(code) {
        this.copyToClipboard(code)

        this.$vs.notify({
            title:'Success',
            text:'Embed code has been copy to clipboard',
            color:'success',
            position:'bottom-center'
        })
      },
      copyToClipboard(text) {
          var dummy = document.createElement("textarea");
          // to avoid breaking orgain page when copying more words
          // cant copy when adding below this code
          // dummy.style.display = 'none'
          document.body.appendChild(dummy);
          //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
          dummy.value = text;
          dummy.select();
          document.execCommand("copy");
          document.body.removeChild(dummy);
      }
    }
  }
</script>

<style scoped>
  .table-site-access td {
    padding: 5px;
    vertical-align: top;
  }
</style>